import React from "react";

const LabelListCell = ({ config, data }) => {
    return data && data.length > 0 ? data.map(d => d.label).join(", ") : null;
}

export default LabelListCell;